import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl2 = `${httpUrl.host}/gy-apartment`;

let api = {
  // 监测点管理——分页
  getMonitorPointPage: `${baseUrl}/monitorPoint/getPage`,

  // 监测点管理——添加
  addMonitorPoint: `${baseUrl}/monitorPoint/add`,

  // 监测点管理——修改
  updateMonitorPoint: `${baseUrl}/monitorPoint/update`,

  // 监测点管理——删除
  deleteMonitorPoint: `${baseUrl}/monitorPoint/deleteByCodes`,

  // 监测点管理——详情
  getMonitorPointByCode: `${baseUrl}/monitorPoint/getByCode`,

  // 监测点管理——设备列表
  getVideoDeviceList: `${baseUrl2}/videoDevice/getList`,

  // 客流统计——设备列表
  getMonitorPointList: `${baseUrl}/monitorPoint/getList`,

  // 客流统计——导出
  exportStatistics: `${baseUrl}/statistics/export`,

  //客流统计——分页
  getStatisticsPage: `${baseUrl}/statistics/getPage`,

  //概览——流量图表
  getStatisticsByType: `${baseUrl}/overview/getStatisticsByType`,

  //概览——流量图表
  getOverview: `${baseUrl}/overview`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/CustomerFlow.js